<template>
  <div class="login">
    <navbar />

    <b-container fluid>
      <b-row class="my-5 text-center">
        <b-col>
          <img
            class="mb-2"
            height="150"
            src="../assets/logo.png"
            alt="Codingbee logo"
          />
          <h1>{{ isLogin ? "Login" : "Sign Up" }}</h1>
        </b-col>
      </b-row>

      <b-row v-if="isLogin" class="mb-5">
        <b-col md="4" offset-md="4">
          <b-form @submit.prevent="onLogin">
            <b-col>
              <b-form-group label="Login email:" label-for="login-email-input">
                <b-form-input
                  id="login-email-input"
                  v-model="login.email"
                  type="email"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col>
              <b-form-group label="Password:" label-for="login-password-input">
                <b-form-input
                  id="login-password-input"
                  v-model="login.password"
                  type="password"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-button variant="primary" type="submit" :disabled="isLoggingIn">
                <b-spinner small v-if="isLoggingIn"></b-spinner>
                Login
              </b-button>
              <b-button variant="link" class="ml-2" @click="toggleLoginMode">
                Sign Up
              </b-button>
            </b-col>
          </b-form>
        </b-col>
      </b-row>

      <b-row v-else class="mb-5">
        <b-col md="6" offset-md="3">
          <b-form @submit.prevent="onSignUp">
            <b-row>
              <b-col md="12">
                <b-form-group label="I am a" label-for="role-input">
                  <b-form-select v-model="form.role" class="mb-3" required>
                    <b-form-select-option value="student">
                      student
                    </b-form-select-option>
                    <b-form-select-option value="parent">
                      parent
                    </b-form-select-option>
                    <b-form-select-option value="educator">
                      educator
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col v-if="form.role == 'student'">
                <b-form-group label="Student name:" label-for="name-input">
                  <b-form-input
                    v-model="form.studentName"
                    id="name-input"
                    type="text"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col v-if="form.role == 'parent'">
                <b-form-group label="Parent name:" label-for="name-input">
                  <b-form-input
                    v-model="form.parentName"
                    id="name-input"
                    type="text"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col v-if="form.role == 'educator'">
                <b-form-group label="Educator name:" label-for="name-input">
                  <b-form-input
                    v-model="form.educatorName"
                    id="name-input"
                    type="text"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group label="School:" label-for="school-input">
                  <b-form-input
                    v-model="form.school"
                    id="school-input"
                    type="text"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col v-if="form.role == 'educator'">
                <b-form-group label="Position:" label-for="position-input">
                  <b-form-input
                    v-model="form.position"
                    id="position-input"
                    type="text"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="form.role != 'educator'">
              <b-col md="6">
                <b-form-group label="Student age:" label-for="age-input">
                  <b-form-input
                    v-model="form.age"
                    id="age-input"
                    type="number"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Student grade:" label-for="age-input">
                  <b-form-select v-model="form.grade" class="mb-3" required>
                    <option value="Standard 1">Standard 1</option>
                    <option value="Standard 2">Standard 2</option>
                    <option value="Standard 3">Standard 3</option>
                    <option value="Standard 4">Standard 4</option>
                    <option value="Standard 5">Standard 5</option>
                    <option value="Standard 6">Standard 6</option>
                    <option value="Form 1">Form 1</option>
                    <option value="Form 2">Form 2</option>
                    <option value="Form 3">Form 3</option>
                    <option value="Form 4">Form 4</option>
                    <option value="Form 5">Form 5</option>
                    <option value="Year 5 (Cambridge)">
                      Year 5 (Cambridge)
                    </option>
                    <option value="Year 6 (Cambridge)">
                      Year 6 (Cambridge)
                    </option>
                    <option value="Year 7 (Cambridge)">
                      Year 7 (Cambridge)
                    </option>
                    <option value="Year 8 (Cambridge)">
                      Year 8 (Cambridge)
                    </option>
                    <option value="Year 9 (Cambridge)">
                      Year 9 (Cambridge)
                    </option>
                    <option value="Year 10 (IGCSE)">Year 10 (IGCSE)</option>
                    <option value="Year 11 (IGCSE)">Year 11 (IGCSE)</option>
                    <option value="Foundation &amp; equivalent">
                      Foundation &amp; equivalent
                    </option>
                    <option value="Degree">
                      Degree
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group label="Login email:" label-for="email-input">
                  <b-form-input
                    id="email-input"
                    v-model="form.email"
                    type="email"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group label="Password:" label-for="password-input">
                  <b-form-input
                    id="password-input"
                    v-model="form.password"
                    type="password"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  label="Confirm Password:"
                  label-for="confirm-password-input"
                >
                  <b-form-input
                    id="confirm-password-input"
                    v-model="form.confirmPassword"
                    type="password"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="mb-4">
              <b-col>
                <b-button
                  variant="primary"
                  type="submit"
                  :disabled="isSigningUp"
                >
                  <b-spinner small v-if="isSigningUp"></b-spinner>
                  Sign Up
                </b-button>
                <b-button variant="link" class="ml-2" @click="toggleLoginMode">
                  Login existing account
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-col>
      </b-row>
    </b-container>

    <app-footer />
  </div>
</template>

<script>
import AppFooter from "@/components/AppFooter.vue";
import Navbar from "@/components/Navbar.vue";
import AuthServices from "@/services/auth-services";
import UserServices from "@/services/user-services";

/* import firebase from "firebase";
import { auth } from "@/services/firebase";

import UserServices from "@/services/user-services"; */

export default {
  name: "Login",

  components: {
    Navbar,
    AppFooter
  },

  data() {
    return {
      isLogin: false,
      isSigningUp: false,
      isLoggingIn: false,
      form: {
        role: "student"
      },
      login: {
        email: null,
        password: null
      }
    };
  },

  mounted() {},

  methods: {
    onLogin() {
      this.isLoggingIn = true;
      const self = this;
      AuthServices.loginUser(this.login)
        .then(userCredential => {
          let user = userCredential.user;
          user.id = user.uid;
          self.$store.commit("user/updateUser", user);
          self.$router.push("/dashboard");
        })
        .catch(error => {
          alert(error.message);
          this.isLoggingIn = false;
        });
    },

    onSignUp() {
      const self = this;

      if (this.form.password != this.form.confirmPassword) {
        return alert("Password does not match!");
      }

      this.isSigningUp = true;

      AuthServices.signupNewUser(this.form).then(userCredential => {
        let user = userCredential.user;
        this.form.id = user.uid;
        UserServices.addUser(this.form).then(() => {
          self.$store.commit("user/updateUser", this.form);
          self.$router.push("/dashboard");
        });
      });
    },

    toggleLoginMode() {
      this.isLogin = !this.isLogin;
    }
  }
};
</script>
